export class NodeEntity {
  id: number;
  caption: string;
  hasChildren: boolean;
  parentNodeId: number;
  closeDate?: string;
  openDate?: string;
  fileMap?: string;
  floorplan?: string;
  isClosePermanently?: boolean;
  icon?: string;
  iconDashboard?: string;
  iconKey?: string;
  iconX32?: string;
  childNodes?: NodeEntity[];
  preCloseDate?: string;

  constructor(data?: Partial<NodeEntity>) {
    this.id = data?.id || 0;
    this.caption = data?.caption || "";
    this.hasChildren = data?.hasChildren || false;
    this.parentNodeId = data?.parentNodeId || 0;
    this.closeDate = data?.closeDate || undefined;
    this.openDate = data?.openDate || undefined;
    this.fileMap = data?.fileMap || undefined;
    this.floorplan = data?.floorplan || undefined;
    this.isClosePermanently = data?.isClosePermanently || false;
    this.icon = data?.icon || undefined;
    this.iconDashboard = data?.iconDashboard || undefined;
    this.iconKey = data?.iconKey || undefined;
    this.iconX32 = data?.iconX32 || undefined;
    this.childNodes = data?.childNodes ? data.childNodes.map((item) => new NodeEntity(item)) : [];
    this.preCloseDate = data?.preCloseDate || undefined;
  }
}
